module.exports = __webpack_public_path__ + "static/media/Green_forest1.89e47852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Environments/Green_forest1.jpg
// module id = 209
// module chunks = 0